var pageBg = {
    "\/pages\/our-philosophy": {
        "url": "https:\/\/cdn.shopify.com\/s\/files\/1\/1934\/6743\/files\/splendor_brilldor_jewellery_shop_store_saloon_workshop_location_place_headquarter_enterieur_indoor_showroom_daniel_orsolya_orsi_designer_df5c0002-aa09-44f7-9a74-debe2271e272_1600x.jpg?v=1505381559",
        "magassag": "700",
        "pozicio": "-100"
    },
    "\/pages\/awards": {
        "url": "https:\/\/cdn.shopify.com\/s\/files\/1\/1934\/6743\/files\/splendor_brilldor_jewellery_shop_store_saloon_workshop_location_place_headquarter_enterieur_indoor_showroom_daniel_orsolya_orsi_designer_df5c0002-aa09-44f7-9a74-debe2271e272_1600x.jpg?v=1505381559",
        "magassag": "",
        "pozicio": ""
    }
};